import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles3 from '../../styles/LeadsHelpful.module.scss';
import FeedbackPopup from '../Leads/FeedbackPopup';
import { onClickEvent } from '../../lib/gaAnalytics';
import { clickTracker, getContractTypeVal, getProjectId, helpfulObj } from '../../lib/common';
import { useLocalStorage } from '../../hooks';
import { handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

export default function Helpfull({ redirectkey }) {
  const navigate = useNavigate();
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [helpfulData, setHelpfulData] = useState(helpfulObj && helpfulObj);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const selectedFeedback = sessionStorage.getItem('feedback');
  const projectId = getProjectId();
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio')) || {};
  const [authState] = useAuth();
  const contractVal = getContractTypeVal(projectId);

  useEffect(() => {
    if (helpfulData[1]?.isActive) {
      window.scroll({
        top: document.body.offsetHeight,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [helpfulData[1]]);

  const handleCloseFeedbackPopup = () => {
    document.body.style.overflow = 'unset';
    setShowFeedbackPopup(false);
  };

  const handleisHelpfulClick = async (index) => {
    sessionStorage.setItem('feedback', index === 0 ? 'Helpful' : 'NotHelpful');
    setHelpfulData((prevObj) =>
      prevObj.map((each, i) => (i === index ? { ...each, isActive: !each.isActive } : { ...each, isActive: false })),
    );

    if (redirectkey === 'leads') {
      onClickEvent(
        `${`Leads-healthCheck-${selectedBusiness?.docid}`}`,
        `${`Leads-healthCheck-${selectedBusiness?.docid}`} ${helpfulObj[index]?.val ? 'Helpful' : 'Not Helpful'}`,
        '',
      );
    }

    if (index === 0) {
      setShowFeedbackPopup(true);
    }
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `click_feedback_${index === 0 ? 'yes' : 'no'}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `click_${redirectkey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
    const feedbackTypeLI = `feedback_${index === 0 ? 'yes' : 'no'}`;
    if (redirectkey === 'edit_my_business') {
      await clickTracker(feedbackTypeLI, 'editdata_feedback');
    } else if (redirectkey === 'ecs') {
      await clickTracker(feedbackTypeLI, `${redirectkey}_feedback`);
    } else {
      await clickTracker(
        feedbackTypeLI,
        projectId === 'csportal' ? `${redirectkey}_feedback` : `geniocs_${redirectkey}_feedback`,
      );
    }
  };
  const handleTicketCreate = async () => {
    const genioContractLI = projectId === 'genio' && redirectkey === 'contract';
    const raiseTicketLI = redirectkey === 'edit_my_business' ? 'editdata' : redirectkey;
    await clickTracker('raiseticket', genioContractLI ? 'genio_contract_feedback' : `${raiseTicketLI}_feedback`);
    const parentid = projectId === 'csportal' ? selectedBusiness?.parentid : selectedBusinessGenio?.parentId;
    const city = projectId === 'csportal' ? selectedBusiness?.data_city : selectedBusinessGenio?.city;
    if (parentid && city) {
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = 'click_raiseticket';
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = `click_${redirectkey}`;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
      if (projectId === 'csportal' && ['paid', 'expiredShort'].includes(contractVal)) {
        // navigate('/csportal/create_ticket_new');
        navigate(
          `/${projectId}/create_ticket?parentId=${parentid}&city=${city}&key=${
            ['payments', 'contract'].includes(redirectkey) ? 'Contract-Information' : redirectkey
          }&raiseTicketTrackerID=${redirectkey}`,
        );
      } else
        navigate(
          `/${projectId}/create_ticket?parentId=${parentid}&city=${city}&key=${
            ['payments', 'contract'].includes(redirectkey) ? 'Contract-Information' : redirectkey
          }&raiseTicketTrackerID=${redirectkey}`,
        );
    }
  };
  return (
    <>
      <div className={`${styles3.LeadsHelpful} p-20`}>
        <div className="font16 fw500 color111">Was this helpful?</div>
        <div className={`${styles3.LeadsHelpful__box} mt-20`}>
          {helpfulData &&
            helpfulData.map((each, i) => (
              <div
                aria-label="helpful_change"
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
                onClick={() => {
                  handleisHelpfulClick(i);
                }}
                key={each.id}
                className={`${styles3.LeadsHelpful__BoxItem} whitefill_animate `}
              >
                <img alt={each.alt} className={`${styles3.LeadsHelpful__Image} `} src={each.icon} />
                <div className={`${styles3.LeadsHelpful__Textbox} `}>
                  <div
                    className={`font14 fw700 ${
                      each.isActive ||
                      (each.id === 0 && selectedFeedback === 'Helpful') ||
                      (each.id === 1 && selectedFeedback === 'NotHelpful')
                        ? each.color
                        : ''
                    }`}
                  >
                    {each.val ? 'Yes' : 'No'}
                  </div>
                  <div className="font11 fw400 color111">{each.text}</div>
                </div>
              </div>
            ))}
        </div>
      </div>
      {((helpfulData && helpfulData[1]?.isActive) || selectedFeedback === 'NotHelpful') && (
        <div className="font16 fw700 color111 p-20">
          Issue not yet resolved?
          <div className={styles3.RaiseTicketButton}>
            <button
              onClick={async () => handleTicketCreate()}
              type="button"
              className={`${styles3.Accordion__Contant__Button} ${styles3.bluefill_animate} font14 fw600 colorFFF mt-10`}
            >
              Raise a Ticket
            </button>
          </div>
          <div className="font11 fw400 color777 mb-15 text_center mt-6">
            Our team will get back to you within 48 hours
          </div>
        </div>
      )}
      {showFeedbackPopup && <FeedbackPopup handleCloseFeedbackPopup={handleCloseFeedbackPopup} id="feedback" />}
    </>
  );
}
Helpfull.propTypes = {
  redirectkey: PropTypes.string,
};
